













import { GuildViewObject } from '@/types/apiServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';
import GuildBankTabs from '@/components/frontpage/armory/guilds/GuildBankTabs.vue';

@Component({
    components: { GuildBankTabs }
})
export default class GuildBank extends Vue {
    @Prop({ required: true, type: Number })
    realmId!: number;

    @Prop({ required: true, type: Object })
    guild!: GuildViewObject;
}
